import { upperFirst, includes } from 'lodash';

export function cleanTitle(text = '') {
	const specialWords = ['of', 'at'];
	const words = text.split('-');
	return words.map((word) => (includes(specialWords, word) ? word : upperFirst(word))).join(' ');
}
